(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('SendMessageModalController', SendMessageModalController);

    function SendMessageModalController($uibModalInstance, $state, campaign, activity, $window, $translate, onSendMessage) {
        var vm = this;

        vm.campaign = angular.copy(campaign);
        vm.activity = angular.copy(activity);

        if (vm.activity && vm.activity.campaign && vm.activity.campaign.content) {
            vm.campaign.content = vm.activity.campaign.content;
        }

        vm.messageSent = false;

        vm.cancel = function() {
            $uibModalInstance.close();
        };

        vm.getCustomerName = function () {
            if (vm.activity.customer.fullName) {
                return vm.activity.customer.fullName.split(' ')[0];
            }
            return '';
        };

        vm.sendMessage = function () {
            var phone = vm.activity.customer.phone.replace(/\D/g, '');
            var url = 'https://api.whatsapp.com/send/?phone=' + phone + '&text=' + encodeURI(vm.campaign.content);

            if (!angular.isFunction(onSendMessage)) {
                $window.open(url, '_blank');
                vm.messageSent = true;
                return;
            }

            onSendMessage().then(function (canOpen) {
                if (canOpen) {
                    $window.open(url, '_blank');
                    vm.messageSent = true;
                }
            });
        };

        vm.finishActivity = function (value) {
            $uibModalInstance.close(value);
        };

        function replaceMessage() {
            if (vm.campaign.content) {
                var nameValue = $translate.instant("campaign.markers.value.name");
                var customerName = vm.getCustomerName();
                var regex = new RegExp('{{\\s*' + nameValue + '\\s*}}', 'g');

                vm.campaign.content = vm.campaign.content.replace(regex, customerName);
            }
        }

        function onInit() {
            replaceMessage();
        }

        onInit();

    }

})();
